export enum ContentErrorsEnum {
  CREATE_DEFAULT = 'Ошибка при загрузке изображения.',
}

export const ContentErrors = {
  CREATE: {
    400: 'Неверный формат изображения.',
    413: 'Изображение слишком большое.',
    500: 'Ошибка сервера при создании изображения.',
  },
};
